import React from 'react'

function QuestionSub1({ width, height, className, color = "currentColor" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            className={className}
            viewBox="0 0 12.551 12.551"
            fill={color} // Apply dynamic fill color
        >
            <path d="M1.395,12.551a1.342,1.342,0,0,1-.985-.409A1.345,1.345,0,0,1,0,11.156V1.395A1.341,1.341,0,0,1,.41.41,1.346,1.346,0,0,1,1.395,0h9.762a1.343,1.343,0,0,1,.985.41,1.34,1.34,0,0,1,.409.985v9.762a1.4,1.4,0,0,1-1.395,1.395Zm0-1.395h9.762V1.395H1.395Zm.7-1.395h8.367L7.844,6.275,5.752,9.064,4.184,6.973Z" />
        </svg>
    )
}

export default QuestionSub1